// @flow

import * as React from "react"
import ShopAdminSearchItemListItem from "./search-item-list-item"
import {includes} from "lodash"
import {connect} from "react-redux"
import {
  isSearchItemSubSelected,
  isAnySearchItemSetSelectedExcluding,
} from "../../../reducers/shop"
import type {SearchItem, Dispatch, State as ReduxState} from "../../../types"

type Props = {
  items: $ReadOnlyArray<SearchItem>,
  selectedSearchItems: $ReadOnlyArray<string>,
  dispatch: Dispatch,
}

class ShopAdminSearchItemList extends React.Component<Props> {
  render() {
    const {items, selectedSearchItems} = this.props
    return (
      <ul className="shop-admin-search-item-list">
        {items.map((item) => {
          const isDisabled =
            (item.isSet && selectedSearchItems.length > 1) ||
            isAnySearchItemSetSelectedExcluding(
              items,
              selectedSearchItems,
              item.key
            ) ||
            isSearchItemSubSelected(item.key, items, selectedSearchItems)
          return (
            <ShopAdminSearchItemListItem
              key={item.key}
              item={item}
              isSelected={includes(selectedSearchItems, item.key)}
              isDisabled={isDisabled}
            />
          )
        })}
      </ul>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  selectedSearchItems: state.shop.selectedSearchItems,
})

export default connect(mapStateToProps)(ShopAdminSearchItemList)
